import React, { lazy, Suspense, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import StaticPage from 'src/components/StaticPage/StaticPage'
import {
  selectAppName,
  selectBrandName,
  selectExternalTermsUrl,
} from 'src/redux/selectors/session.selectors'

const Terms: React.FC = () => {
  const brandName = useSelector(selectBrandName)
  const externalTermsUrl = useSelector(selectExternalTermsUrl)
  const appName = useSelector(selectAppName)
  const TermsComponent = useMemo(
    () =>
      externalTermsUrl === undefined
        ? lazy(() => import(`src/branded/${brandName}/Terms/Terms`))
        : (): null => {
            window.location.href = externalTermsUrl
            return null
          },
    [brandName],
  )

  return (
    <StaticPage>
      <Helmet>
        <title>{`Terms and Conditions | ${appName}`}</title>
        <meta
          name="description"
          content={`The Terms and Conditions explains how ${appName} govern your use of our services.`}
        />
      </Helmet>
      <Suspense fallback={<LoadingBackgroundPage />}>
        <TermsComponent />
      </Suspense>
    </StaticPage>
  )
}

export default Terms
